import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box
} from '@mui/material';
import { CreditCard, LocationOn, AccountBalance } from '@mui/icons-material';
import { memo } from 'react';
import { useTranslation } from "react-i18next";

interface PaymentMethodSectionProps {
  value: string;
  onChange: (value: string) => void;
}

const paymentOptions = [
  {
    value: "PAY_ONLINE",
    key: "pay_online",
    icon: CreditCard,
  },
  {
    value: "PAY_AT_SALON",
    key: "pay_at_salon",
    icon: LocationOn,
  },
  {
    value: "BOTH",
    key: "both",
    icon: AccountBalance,
  },
];

const PaymentMethodSectionComponent = ({ value, onChange }: PaymentMethodSectionProps) => {
  const { t } = useTranslation();
  return (
    <Card elevation={2}>
      <CardHeader
        avatar={<CreditCard sx={{ color: '#ba2156' }} />}
        title={
          <Typography variant="h6" component="h3">
            {t("salon.settings.payment.title")}
          </Typography>
        }
        subheader={
          <Typography variant="body2" color="text.secondary">
            {t("salon.settings.payment.subtitle")}
          </Typography>
        }
      />
      <CardContent>
        <FormControl component="fieldset">
          <RadioGroup value={value} onChange={(e) => onChange(e.target.value)}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {paymentOptions.map((option) => {
                const Icon = option.icon;
                return (
                  <Box
                    key={option.value}
                    sx={{
                      p: 2,
                      border: '1px solid',
                      borderColor: 'grey.300',
                      borderRadius: 2,
                      '&:hover': { bgcolor: 'action.hover' },
                      transition: 'background-color 0.2s'
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <FormControlLabel
                        value={option.value}
                        control={
                          <Radio 
                            sx={{ 
                              color: '#ba2156', 
                              '&.Mui-checked': { color: '#ba2156' } 
                            }} 
                          />
                        }
                        label=""
                      />
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                        <Box 
                          sx={{ 
                            width: 32, 
                            height: 32, 
                            borderRadius: '50%', 
                            bgcolor: 'rgba(186, 33, 86, 0.1)', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center' 
                          }}
                        >
                          <Icon sx={{ fontSize: 16, color: '#ba2156' }} />
                        </Box>
                        <Box>
                          <Typography variant="body1">{t(`salon.settings.payment.options.${option.key}.label`)}</Typography>
                          <Typography variant="body2" color="text.secondary">
                            {t(`salon.settings.payment.options.${option.key}.description`)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </RadioGroup>
        </FormControl>
      </CardContent>
    </Card>
  );
};

export const PaymentMethodSection = memo(PaymentMethodSectionComponent);